export default interface CouponsEntity {
	_id?: string
	type: TypesCoupon
	code?: string
	discount: number
	amount?: number
	expiration: string
	_created?: string
	_modified?: string
	_deleted?: boolean
}

export enum TypesCoupon {
	AMOUNT = 'amount',
	DISCOUNT = 'discount',
}
